// extracted by mini-css-extract-plugin
module.exports = {"section":"ComplimentaryEvents_section__2smuT","title":"ComplimentaryEvents_title__1jdwm"};